import React from 'react';
import {stringToHash} from "../utils/profile_picture";

const ProfilePicture = ({ username, profilePicture, size = 24, fontSize = 13 }) => {

    const hash = stringToHash(username);
    const index = hash % 11;
    const items = ["aa47bc","c2175b","8c6e63","7e57c2","00579c","5d4038","33691e","78909c","689f39","512da7","f5511e"];

    const firstLetter = username.charAt(0).toUpperCase();

    return (
        <div style={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: profilePicture ? 'transparent' : `#${items[index]}`,
            overflow: 'hidden',
        }}>
            {profilePicture ? (
                <img
                    src={profilePicture}
                    alt={username}
                    style={{ width: '100%', height: '100%' }}
                />
            ) : (
                <span style={{
                    color: 'white',
                    fontSize: `${fontSize}px`,
                    fontWeight: 500
                }}>
          {firstLetter}
        </span>
            )}
        </div>
    );
};

export default ProfilePicture;